// Файл download_blob.js

/**
 * Модуль обслуживает сценарий `download_blob` в разделе `utils`.
 * Он содержит обработчики и данные, относящиеся к этой части клиентского
 * интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

export const download_blob = (
    blob, file_name = 'download'
) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = String(
        file_name || 'download').trim() || 'download';
    document.body.appendChild(link);
    link.click();
    link.remove();

    setTimeout(
        () => window.URL.revokeObjectURL(url),
        1000
    );
};
